import * as React from "react";

const SvgSearchcircle = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill={color} fillRule="nonzero">
      <path d="M7.293 15.293a1 1 0 1 0 1.414 1.414l-1.414-1.414ZM15 11a2 2 0 0 1-2 2v2a4 4 0 0 0 4-4h-2ZM11 11a2 2 0 0 1 2-2V7a4 4 0 0 0-4 4h2ZM13 9a2 2 0 0 1 2 2h2a4 4 0 0 0-4-4v2Z" />
      <path d="m10.172 12.414-2.88 2.879 1.415 1.414 2.879-2.879z" />
      <path d="M13 13a1.99 1.99 0 0 1-1.414-.586l-1.414 1.414A3.99 3.99 0 0 0 13 15v-2Z" />
      <path d="M11.586 12.414A1.99 1.99 0 0 1 11 11H9a3.99 3.99 0 0 0 1.172 2.828l1.414-1.414ZM20 12a8 8 0 0 1-8 8v2c5.523 0 10-4.477 10-10h-2ZM12 20a8 8 0 0 1-8-8H2c0 5.523 4.477 10 10 10v-2Z" />
      <path d="M4 12a8 8 0 0 1 8-8V2C6.477 2 2 6.477 2 12h2ZM12 4a8 8 0 0 1 8 8h2c0-5.523-4.477-10-10-10v2Z" />
    </g>
  </svg>
);

export default SvgSearchcircle;
